exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".internal {\n    width: 100%;\n    height: 100%;\n}\n\n.container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n }\n\n body, html {\n    height: 100%;\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/pdfviewer/pdfviewer.component.css
// module id = ../../../../../src/app/pdfviewer/pdfviewer.component.css
// module chunks = main